import {
  CHANGE_LANGUAGE,
  CHANGE_LOCATION,
  REQUEST_LOGIN,
  REQUEST_LOGIN_FAILED,
  REQUEST_LOGIN_SUCCESS,
  REQUEST_LOGOUT,
  REQUEST_LOGOUT_FAILED,
  REQUEST_LOGOUT_SUCCESS,
  VALIDATE_AUTH,
  VERIFY_NEW_ACCOUNT,
} from '../constants';
import { createActions } from 'redux-actions';

export const {
  requestLogin,
  requestLoginSuccess,
  requestLoginFailed,
  requestLogout,
  requestLogoutSuccess,
  requestLogoutFailed,
  requestSignup,
  requestSignupSuccess,
  requestSignupFailed,
  changeLocation,
  changeLanguage,
  validateAuth,
  verifyNewAccount,
} = createActions(
  REQUEST_LOGIN,
  REQUEST_LOGIN_SUCCESS,
  REQUEST_LOGIN_FAILED,
  REQUEST_LOGOUT,
  REQUEST_LOGOUT_SUCCESS,
  REQUEST_LOGOUT_FAILED,
  CHANGE_LOCATION,
  CHANGE_LANGUAGE,
  VALIDATE_AUTH,
  VERIFY_NEW_ACCOUNT
);
